<script lang="ts">
	import { Button, ButtonSize, ButtonType } from '@repo/commons/components'
	import type { ReferenceTableRow } from '@repo/commons/models'
	import { downloadReferenceTableCsv, importReferenceTableCsv } from '@repo/commons/utils'
	import type { ResourceSchema } from '@semanticedge/persistence-service-noheaders-client/src'
	import { t } from 'svelte-i18n'

	type Props = {
		title: string
		rows: readonly ReferenceTableRow[]
		schema: ResourceSchema | undefined
		onImport: (rows: ReferenceTableRow[]) => Promise<boolean>
	}

	const { title, rows, schema, onImport }: Props = $props()

	let csvFileInput = $state<HTMLInputElement | null>(null)

	const handleExport = (): void => {
		if (!title) return

		downloadReferenceTableCsv(rows, title, schema)
	}

	const openFilePicker = (): void => {
		csvFileInput?.click()
	}

	const handleFileChosen = async (
		event: Event & { currentTarget: HTMLInputElement }
	): Promise<void> => {
		const input = event.currentTarget
		const [file] = input.files ?? []

		if (file) {
			await importReferenceTableCsv({ file, schema, currentRowCount: rows.length, onImport })
		}

		input.value = ''
	}
</script>

<Button
	buttonType={ButtonType.NEUTRAL}
	buttonSize={ButtonSize.LARGE}
	buttonText={$t('ReferenceTableRowsView.exportCsv')}
	iconProps={{ name: 'download', size: 'sm' }}
	onclick={handleExport}
/>
<Button
	buttonType={ButtonType.NEUTRAL}
	buttonSize={ButtonSize.LARGE}
	buttonText={$t('ReferenceTableRowsView.importCsv')}
	iconProps={{ name: 'upload', size: 'sm' }}
	onclick={openFilePicker}
/>
<input
	bind:this={csvFileInput}
	type="file"
	accept=".csv"
	class="csv-file-input"
	onchange={handleFileChosen}
/>

<style lang="postcss">
	.csv-file-input {
		@apply hidden;
	}
</style>
